import React from "react";
import { useEffect, useState } from "react";

function ReturnImage({ imageName, classname, alt, viewport }) {
    const [validVariants, setValidVariants] = useState([]);

    useEffect(() => {
        let imageVariants = [400, 800, 1200, 1600];

        // for (let i = 1; i < 1401; i++) {
        //     imageVariants.push(i);
        // }
      
        const basePath = `${process.env.PUBLIC_URL}/images/`;
      
        const checkImageExists = (url) => {
          return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
            img.src = url;
          });
        };
      
        const checks = imageVariants.map(width => {
          const path = `${imageName}-${width}.jpg`;
          const fullUrl = basePath + path;
      
          return checkImageExists(fullUrl).then(exists => {
            return exists ? { width, path } : null;
          });
        });
      
        Promise.all(checks).then(results => {
          const valid = results.filter(Boolean); // retire les null
          setValidVariants(valid);
        });
    }, [imageName]);

    // Construction du srcSet
    const srcSet = validVariants
    .map(v => `${process.env.PUBLIC_URL}/images/${v.path} ${v.width}w`)
    .join(', ');

    const fallbackSrc = `${process.env.PUBLIC_URL}/images/${imageName}.jpg`;

    return (
        <img
            className={classname}
            sizes={`(max-width: 1440px) 100vw, ${viewport ?? 100}vw`}
            srcSet={srcSet || fallbackSrc}
            src={fallbackSrc}
            loading="lazy"
            alt={alt ?? ''}
            title={alt ?? ''}
          />
    )
}

export default ReturnImage;